import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DVFormArray, DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import * as _ from 'lodash';
@Component({
  selector: 'app-add-experience-day',
  templateUrl: './add-experience-day.component.html',
  styleUrls: ['./add-experience-day.component.css']
})
export class AddExperienceDayComponent implements OnInit {
  @Input() experienceForm: DVFormGroup;
  private expDays: DVFormArray;

  ngOnInit() {
    this.expDays = this.experienceForm.controls
      .ExperienceDays as DVFormArray;
    this.experienceForm.controls.duration.valueChanges.subscribe(duration => {
      if (duration > this.expDays.length) {
        this.addDays(duration);
      } else if (duration < this.expDays.length) {
        this.removeDays(duration);
      }
    });
  }

  private addDays(duration) {
    const currentLength = this.expDays.length;
    const difference = duration - currentLength;
    for (let i = 0; i < difference; i++) {
      this.expDays.addChildrenToArray(
        this.generateExperienceDay()
      );
    }
  }

  private removeDays(duration) {
    const currentLength = this.expDays.length;
    for (let i = currentLength; i > duration; i--) {
      this.expDays.removeAt(i - 1);
    }
  }

  get experienceDaysAsFormArray() {
    return this.experienceForm.controls.ExperienceDays as DVFormArray;
  }

  getActivityFromExpDayForm(expDay: DVFormGroup) {
    return expDay.controls.Activities as DVFormArray;
  }

  private generateExperienceDay() {
    return new DVFormGroup({
      id: new DVFormControl(),
      order: new DVFormControl(),
      title: new DVFormControl(),
      meals: new DVFormControl(null),
      overnight: new DVFormControl(null),
      description: new DVFormControl(null),
      Activities: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'title',
            type: 'CONTROL',
            default: null,
            validators: {
              'Title is required': Validators.required
            }
          },
          {
            name: 'order',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'description',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'Pictures',
            type: 'CONTROL',
            default: [],
          }
        ],
        1,
        {
          'Day Activites': Validators.nullValidator
        }
      )
    });
  }
}
